module.exports = __webpack_public_path__ + "9488d02b/img/comments-icon.fdec7fdb.svg";